module.exports = __webpack_public_path__ + "static/media/homeBannerRetouch.a22adf1f.png";